export default __webpack_public_path__ + "pdfjs-dist-ie11-ledge/pdf.worker.min-ecde6577fb6a19d30559a3a472f55507.js";